import cn from 'classnames';
import Link from 'next/dist/client/link';

import { Pagination } from '@webapp/common/components/pagination';
import { BLOG_PAGE_SIZE } from '@webapp/common/lib/const';
import { createLandingUrl } from '@webapp/common/lib/utils';

import cssPage from '../static-page/static-page.css';

import { BlogCard } from './card';
import type { IBlogCards } from './lib';

import css from './blog-cards.css';

const paginationLabelRenderer = (label: string | number, element: ReactNode, rel?: string): ReactNode =>
    typeof label === 'string' ? (
        label
    ) : (
        <Link href={createLandingUrl(`/ru/blog?page=${label}`)}>
            <a rel={rel}>{element ? element : label}</a>
        </Link>
    );

export const BlogCards: React.FC<{
    cards: IBlogCards;
    page: number;
    totalPages: number;
}> = ({ cards, page, totalPages }) => {
    return (
        <div className={cn(cssPage.staticPage, css.blogCards)}>
            <h1>Блог</h1>
            <div className={css.cards}>
                {cards.map(({ description, link, teaserImg, title }) => (
                    <BlogCard description={description} href={link} key={link} teaserImg={teaserImg} title={title} />
                ))}
            </div>
            <Pagination
                className={css.pagination}
                labelRenderer={paginationLabelRenderer}
                limit={BLOG_PAGE_SIZE}
                page={page}
                totalCount={totalPages}
            />
        </div>
    );
};
